import { IEntityDataService } from "@pit/core-data";
import { IDtoContact, IDtoDepot, IDtoDevice } from "@pit/frontend-model";
import { Observable } from "rxjs";

export interface IDtoDepotEntityDataService extends IEntityDataService<IDtoDepot> {

    getDevicesForMandatorAndDepot$(mandator: string, depot: IDtoDepot): Observable<IDtoDevice[]>;
    getDevicesForMandatorAndDepotAsync(mandator: string, depot: IDtoDepot): Promise<IDtoDevice[]>;

    getDepotsForMandator$(mandatorId: number): Observable<IDtoDepot[]>;
    getDepotsForMandatorAsync(mandatorId: number): Promise<IDtoDepot[]>;

    saveDepotContactForMandator$(mandator: string, depot: IDtoDepot, contact: IDtoContact): Observable<IDtoContact>;
    saveDepotContactForMandatorAsync(mandator: string, depot: IDtoDepot, contact: IDtoContact): Promise<IDtoContact>;

}
